import script from "./BackgroundClouds.vue?vue&type=script&setup=true&lang=js"
export * from "./BackgroundClouds.vue?vue&type=script&setup=true&lang=js"

import "./BackgroundClouds.vue?vue&type=style&index=0&id=4a83e0c3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a83e0c3"]])

export default __exports__